'use client';
import React, { useState } from 'react';
import { IoSearchSharp } from 'react-icons/io5';

const TrkSearch = () => {
  const [ShowSearch, setShowSearch] = useState(false);
  return (
    <>
      <button
        onClick={() => setShowSearch(!ShowSearch)}
        id="trk-search-icon"
        className="menu-icon search-icon header__action-btn"
        aria-label="Search"
      >
        <IoSearchSharp size={32} />
      </button>
      <button type="button" className="menu-mobile-trigger">
        <span />
        <span />
        <span />
        <span />
      </button>
      <div className={`trk-search ${ShowSearch ? 'active' : ''}`}>
        <div className="trk-search__inner">
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder="Search Here"
              aria-label="trk Search Bar"
              aria-describedby="trk-search"
            />
            <button
              onClick={() => setShowSearch(!ShowSearch)}
              type="submit"
              className="trk-search__btn"
              id="trk-search"
            >
              <IoSearchSharp size={32} />
            </button>
          </div>
        </div>
      </div>
      <div
        onClick={() => setShowSearch(!ShowSearch)}
        className={`trk-search__overlay ${ShowSearch ? 'd-block' : ''}`}
      ></div>
    </>
  );
};

export default TrkSearch;
